import React from 'react'

const AgeGroupItem = ({ ageGroups, ageGroupConfig, totalCount }) => {

    const setPercentage = (value) => {
        const percent = totalCount > 0 ? (value * 100) / totalCount : 0;
        return `(${percent?.toFixed(2)}%)`
    };
    return (
        <div style={{ background: 'rgba(100, 149, 237, 0.2)', width: '620px' }} className="card">
            <div className="card-title">{ageGroupConfig?.title}</div>
            <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
                <div style={{ padding: '5px' }}>
                    {ageGroups?.slice(0, 2)?.map((item, idx) => {
                        const renderValue = item?.age_count
                        return (
                            <div className='content-wrap' key={idx} >
                                <div className="card-content">{`${item?.age}:`}</div>
                                <div className="card-value">{renderValue}{setPercentage(renderValue)}</div>
                            </div>
                        )
                    })}
                </div>
                <div style={{ padding: '5px' }}>
                    {ageGroups?.slice(2, 5)?.map((item, idx) => {
                        const renderValue = item?.age_count
                        return (
                            <div className='content-wrap' key={idx} >
                                <div className="card-content">{`${item?.age}:`}</div>
                                <div className="card-value">{renderValue} {setPercentage(renderValue)}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default AgeGroupItem